import { useToast } from '@solfacil/girassol';
import { jwtDecode } from 'jwt-decode';

type ResourceAccess = {
  [client: string]: {
    roles: string[];
  };
};

export default defineNuxtRouteMiddleware(() => {
  const { createErrorToast } = useToast();
  const accessToken = useCookie('access_token');

  if (!accessToken.value) {
    showError({
      message: 'Você não tem permissão para acessar essa página',
      statusCode: 401
    });
    return;
  }

  try {
    const decoded = jwtDecode(accessToken.value) as any;

    if (!decoded.resource_access) {
      showError({
        message: 'Você não tem permissão para acessar essa página',
        statusCode: 401
      });
      return;
    }

    const roles = Object.entries(decoded.resource_access as ResourceAccess).reduce<string[]>((acc, [client, resource]) => {
      const modifiedRoles = resource.roles.map((role: string) => `${client}#${role}`);
      return [...acc, ...modifiedRoles];
    }, []);

    const couponPermission = roles.includes('ecommerce#coupon:read');

    if (!couponPermission) {
      createErrorToast({
        title: 'Acesso negado',
        description: 'Você não tem permissão para acessar esta página.'
      });
      return navigateTo('/');
    }
  } catch (error) {
    showError({
      message: 'Erro ao verificar permissões',
      statusCode: 401
    });
  }
});
